import React, { useState } from 'react';
import axios from 'axios';
import MainNavbar from '../MainNavbar';
import './SearchComponent.css';

const SearchComponent = () => {
  const [activeTab, setActiveTab] = useState('basic');
  const [searchResults, setSearchResults] = useState([]);

  const [basicSearch, setBasicSearch] = useState({
    name: '',
    email: '',
    city: '',
    state: '',
    gender: '',
    profession: ''
  });

  const [advancedSearch, setAdvancedSearch] = useState({
    minAge: '',
    maxAge: '',
    minHeight: '',
    maxHeight: '',
    religion: '',
    caste: '',
    education: '',
    income: '',
    occupation: '',
    family: '',
    habits: '',
    maritalStatus: '',
    locationState: '',
    locationDistrict: '',
    filterProfiles: false,
    viewedProfiles: false,
    photoSettings: false,
    visibleToAll: false,
    protectedPhoto: false
  });

  const handleBasicChange = (e) => {
    setBasicSearch({ ...basicSearch, [e.target.name]: e.target.value });
  };

  const handleAdvancedChange = (e) => {
    setAdvancedSearch({ ...advancedSearch, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setAdvancedSearch({ ...advancedSearch, [e.target.name]: e.target.checked });
  };

  const handleSubmit = async () => {
    const searchData = activeTab === 'basic' ? basicSearch : advancedSearch;

    try {
      const response = await axios.post('https://back.varankal.com/api/search', {
        searchCriteria: searchData,
        searchType: activeTab,  // 'basic' or 'advanced'
      });

      setSearchResults(response.data);
    } catch (error) {
      console.error('Search Error:', error.response ? error.response.data : error.message);
    }
  };


  const handleReset = () => {
    setSearchResults([]);

    if (activeTab === 'basic') {
      setBasicSearch({
        name: '',
        email: '',
        city: '',
        state: '',
        gender: '',
        profession: ''
      });
    } else {
      setAdvancedSearch({
        minAge: '',
        maxAge: '',
        minHeight: '',
        maxHeight: '',
        religion: '',
        caste: '',
        education: '',
        income: '',
        occupation: '',
        family: '',
        habits: '',
        maritalStatus: '',
        locationState: '',
        locationDistrict: '',
        filterProfiles: false,
        viewedProfiles: false,
        photoSettings: false,
        visibleToAll: false,
        protectedPhoto: false
      });
    }
  };

  return (
    <>
      <MainNavbar />
      <div className="container11234">
        <div className="layout-wrapper1123">

          {/* Left Side - Results */}
          <div className="left-panel1123">
            <div className="profile-header1123">
              <h2>Search Results</h2>
              <p className="desc1123">{searchResults.length} profile(s) found</p>
            </div>

            {searchResults.length === 0 ? (
              <p>No profiles to display.</p>
            ) : (
              <div className="results-grid1123">
                {searchResults.map((profile, index) => (
                  <div className="profile-card1123" key={index}>
                    <img src={profile.basicDetails?.profilePicture || '/default.jpg'} alt="profile" className="profile-img1123" />
                    <div className="profile-info1123">
                      <h3>{profile.basicDetails?.name}</h3>
                      <p><strong>Age:</strong> {profile.basicDetails?.age}</p>
                      <p><strong>Email:</strong> {profile.basicDetails?.email}</p>
                      <p><strong>Gender:</strong> {profile.basicDetails?.gender}</p>
                      <p><strong>Qualification:</strong> {profile.basicDetails?.qualification}</p>
                      <p><strong>About:</strong> {profile.basicDetails?.aboutMe}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Right Side - Filters */}
          <div className="right-panel1123">
            <div className="tab-buttons1123">
              <button
                className={`tab-button1123 ${activeTab === 'basic' ? 'active1123' : ''}`}
                onClick={() => setActiveTab('basic')}
              >
                Basic Search
              </button>
              <button
                className={`tab-button1123 ${activeTab === 'advanced' ? 'active1123' : ''}`}
                onClick={() => setActiveTab('advanced')}
              >
                Advanced Search
              </button>
            </div>

            <div className="table-section1123">
              <table className="search-table1123">
                <tbody>
                  {activeTab === 'basic' ? (
                    ['name', 'email', 'city', 'state', 'gender', 'profession'].map((field) => (
                      <tr key={field}>
                        <td><label>{field.charAt(0).toUpperCase() + field.slice(1)}</label></td>
                        <td>
                          <input
                            type="text"
                            name={field}
                            value={basicSearch[field]}
                            onChange={handleBasicChange}
                            className="input1123"
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <>
                      {[
                        { name: 'minAge', type: 'number', label: 'Min Age' },
                        { name: 'maxAge', type: 'number', label: 'Max Age' },
                        { name: 'minHeight', type: 'number', label: 'Min Height' },
                        { name: 'maxHeight', type: 'number', label: 'Max Height' },
                        { name: 'religion' }, { name: 'caste' }, { name: 'education' },
                        { name: 'income' }, { name: 'occupation' }, { name: 'family' },
                        { name: 'habits' }, { name: 'locationState', label: 'State' },
                        { name: 'locationDistrict', label: 'District' }
                      ].map((field) => (
                        <tr key={field.name}>
                          <td><label>{field.label || field.name}</label></td>
                          <td>
                            <input
                              type={field.type || 'text'}
                              name={field.name}
                              value={advancedSearch[field.name]}
                              onChange={handleAdvancedChange}
                              className="input1123"
                            />
                          </td>
                        </tr>
                      ))}

                      <tr>
                        <td><label>Marital Status</label></td>
                        <td>
                          <select
                            name="maritalStatus"
                            value={advancedSearch.maritalStatus}
                            onChange={handleAdvancedChange}
                            className="input1123"
                          >
                            <option value="">Select Marital Status</option>
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Divorced">Divorced</option>
                            <option value="Widowed">Widowed</option>
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="2">
                          <div className="checkbox-group1123">
                            {['filterProfiles', 'viewedProfiles', 'photoSettings', 'visibleToAll', 'protectedPhoto'].map((name) => (
                              <label key={name}>
                                <input
                                  type="checkbox"
                                  name={name}
                                  checked={advancedSearch[name]}
                                  onChange={handleCheckboxChange}
                                  className="checkbox1123"
                                />
                                {name.replace(/([A-Z])/g, ' $1')}
                              </label>
                            ))}
                          </div>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>

              <div className="btn-group1123">
                <button className="search-btn1123" onClick={handleSubmit}>Search</button>
                <button className="reset-btn1123" onClick={handleReset}>Reset</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchComponent;
